module.exports = __webpack_public_path__ + "img/GL.ce1aec1c.svg";